import React from 'react';
import * as mui from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import HistoryEduRoundedIcon from '@mui/icons-material/HistoryEduRounded';
import CopyAllRoundedIcon from '@mui/icons-material/CopyAllRounded';
import NormalTextField from '../../../common/NormalTextField';
import ModernSelect from '../../../common/ModernSelect';

// Modern minimalist styled components
const StyledCard = styled(mui.Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  borderRadius: theme.spacing(1),
  boxShadow: 'none',
  border: '1px solid',
  borderColor: alpha(theme.palette.divider, 0.5),
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
}));

const SectionTitle = styled(mui.Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  fontWeight: 500,
  color: theme.palette.text.primary,
}));

const PrivilegedAccountsTab = (props) => {
  const {
    selectedApps,
    adminData,
    adminroles,
    adminrolesOption,
    admincapabilities,
    adminreview,
    adminfrequency,
    adminreviewdoc,
    capabilitiesOptions,
    AdminYesNoOptions,
    frequencyOptions,
    adminreviewdocOptions,
    handleOpenCopyModal,
    handleAdminRolesChange,
    handleCapabilitiesChange,
    handleAdminReviewChange,
    handleAdminFrequencyChange,
    handleAdminReviewDocChange,
    handleAdminChange,
    handleAdminBlur,
  } = props;

  return (
    <div>
      <mui.Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'center' }}>
        <mui.Tooltip title="Copy Process" onClick={handleOpenCopyModal}>
          <mui.IconButton>
            <CopyAllRoundedIcon sx={{ width: 25, height: 25, color: '#046FB2' }} />
          </mui.IconButton>
        </mui.Tooltip>

        <mui.Tooltip title="Certify Accuracy">
          <mui.IconButton>
            <HistoryEduRoundedIcon sx={{ width: 25, height: 25, color: '#046FB2' }} />
          </mui.IconButton>
        </mui.Tooltip>

        <mui.Tooltip title="Download Process Narrative">
          <mui.IconButton>
            <FileDownloadRoundedIcon sx={{ width: 25, height: 25, color: '#046FB2' }} />
          </mui.IconButton>
        </mui.Tooltip>
      </mui.Box>

      <StyledCard>
        <SectionTitle variant="overline">Administrative Accounts</SectionTitle>
        <mui.Typography variant="subtitle2" sx={{ mb: 2 }}>
          Which roles are considered privileged accounts within {selectedApps.APP_NAME}?
        </mui.Typography>

        <div style={{ marginBottom: '18px' }}>
          <ModernSelect
            label="Admin Roles"
            isMultiSelect={true}
            placeholderText="Select Admin Roles"
            selectedOptions={adminroles}
            selectOptions={adminrolesOption}
            handleChange={handleAdminRolesChange}
          />
        </div>

        <mui.Typography variant="subtitle2" sx={{ mb: 2, mt: 2 }}>
          What are the capabilities of these roles?
        </mui.Typography>
        <div style={{ marginBottom: '18px' }}>
          <ModernSelect
            label="Capabilities"
            isMultiSelect={true}
            placeholderText="Select Capabilities"
            selectedOptions={admincapabilities}
            selectOptions={capabilitiesOptions}
            handleChange={handleCapabilitiesChange}
          />
        </div>

        <mui.Typography variant="subtitle2" sx={{ mb: 1 }}>
          If other capabilities are not included in the list above, provide the details below
        </mui.Typography>
        <NormalTextField
          name="CAPABILITIES_OTHER"
          value={adminData.CAPABILITIES_OTHER}
          onChange={handleAdminChange}
          onBlur={handleAdminBlur}
        />
      </StyledCard>

      <StyledCard>
        <SectionTitle variant="overline">Admin Activity Review</SectionTitle>
        <mui.Typography variant="subtitle2" sx={{ mb: 2 }}>
          Are the admin activities reviewed by the management?
        </mui.Typography>

        <div style={{ marginBottom: '18px' }}>
          <ModernSelect
            label="Review Status"
            isMultiSelect={false}
            placeholderText="Select Confirmation"
            selectedOptions={adminreview}
            selectOptions={AdminYesNoOptions}
            handleChange={handleAdminReviewChange}
          />
        </div>

        <mui.Typography variant="subtitle2" sx={{ mb: 2, mt: 2 }}>
          What is the frequency of the review for the activities of these admin accounts?
        </mui.Typography>
        <div style={{ marginBottom: '18px' }}>
          <ModernSelect
            label="Review Frequency"
            isMultiSelect={false}
            placeholderText="Select Frequency"
            selectedOptions={adminfrequency}
            selectOptions={frequencyOptions}
            handleChange={handleAdminFrequencyChange}
          />
        </div>

        <mui.Typography variant="subtitle2" sx={{ mb: 2, mt: 2 }}>
          How is the review documented?
        </mui.Typography>
        <div style={{ marginBottom: '18px' }}>
          <ModernSelect
            label="Documentation Method"
            isMultiSelect={true}
            placeholderText="Select Documentation Form"
            selectedOptions={adminreviewdoc}
            selectOptions={adminreviewdocOptions}
            handleChange={handleAdminReviewDocChange}
          />
        </div>

        <mui.Typography variant="subtitle2" sx={{ mb: 1 }}>
          If documentation method is not included in the list above, provide the details below
        </mui.Typography>
        <NormalTextField
          name="ADMIN_REVIEW_DOCUMENT_OTHER"
          value={adminData.ADMIN_REVIEW_DOCUMENT_OTHER}
          onChange={handleAdminChange}
          onBlur={handleAdminBlur}
        />
      </StyledCard>
    </div>
  );
};

export default PrivilegedAccountsTab; 